export default __webpack_public_path__ + "assets/models/cabf403c383fc0627f5ffe3d061c7d53.glb";